import React from 'react';
import {Container, Box} from '@mui/material';
import Button from "@mui/material/Button";
import {Article, GitHub, LinkedIn, Newspaper} from "@mui/icons-material";
//import {Phone, Email} from "@mui/icons-material";

const CONTACTS = [
    {icon: <LinkedIn/>, name: 'LinkedIn', link: "https://www.linkedin.com/in/gabriele-castoro/"},
    {icon: <Newspaper/>, name: 'Resume (CV)', link: "/documents/Gabriele-Castoro-CV.pdf"},
    {icon: <GitHub/>, name: 'GitHub', link: "https://github.com/devcastoro"},
    //{icon: <Email />, name: 'Email', link: "mailto:gabriele.castoro@gmail.com" },
    //{icon: <Phone />, name: 'Phone', link: "tel:+393281095579" },
    {icon: <Article/>, name: 'Blog 🇬🇧', link: "https://medium.com/@devcastoro"},
    {icon: <Article/>, name: 'Blog 🇮🇹', link: "https://www.castoro.me"},
];
function Contacts() {

    const handleClick = (link) => {
        window.open(link, '_blank');
    };

    const contactSx = {
        color: 'text.primary',
        '&:hover': {
            backgroundColor: 'action.hover',
        },
    }

    return (
        <Container sx={{padding: '64px 0', overflow: 'hidden'}}>
            {/*<SectionTitle title={'Contacts'} />*/}
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: {xs: '24px', sm: '32px 64px'},
                flexDirection: {xs: 'column', sm: 'row'}
            }}>
                {CONTACTS.map(({icon, name, link}) =>
                    <Button size="large" sx={contactSx} startIcon={icon} onClick={() => handleClick(link)}>
                        {name}
                    </Button>
                )}
            </Box>
        </Container>
    );
}

export default Contacts;